import { useEffect } from 'react';
import { throttle } from 'lodash';

const isTouchBottom = ({ callback, boxRef }) => {
    const showHeight = boxRef.current.clientHeight;
    const scrollTopHeight = boxRef.current.scrollTop;
    const allHeight = boxRef.current.scrollHeight;

    if (allHeight <= showHeight + scrollTopHeight + 180) {
        callback();
    }
};

const useTouchBottom = ({ callback, boxRef }) => {
    const useFn = throttle(() => {
        if (typeof callback === 'function') {
            isTouchBottom({
                callback,
                boxRef,
            });
        }
    }, 500);

    useEffect(() => {
        boxRef.current.addEventListener('scroll', useFn);
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            boxRef?.current?.removeEventListener('scroll', useFn);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useTouchBottom;
